<template>

  <div>
    <creating
      v-if="creating" />
    <iframe
      src="javascript:void(0)"
      class="iframe"
      ref="iframe"
      scrolling="no">
      </iframe>
  </div>

</template>

<script>
export default {
  name: 'HtmlFrame',
  props: {
    html: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      creating: true
    }
  },
  computed: {
    fontSize () {
      return window.getComputedStyle(document.body).fontSize
    },
    fontFamily () {
      return window.getComputedStyle(document.body).fontFamily
    },
    color () {
      return window.getComputedStyle(document.body).color
    }
  },
  watch: {
    html () {
      this.realod()
    },
    url () {
      this.realod()
    }
  },
  mounted () {
    this.realod()
  },
  methods: {
    realod () {
      const iframe = this.$refs.iframe
      iframe.style.height = '0px'
      this.creating = true

      if (this.url) {
        fetch(this.url).then(response => {
          return response.text()
        }).then(body => {
          this.writeIframe(body)
        })
      } else {
        this.writeIframe(this.html)
      }
    },
    writeIframe (html) {
      this.creating = false

      // get frame elements
      const iframe = this.$refs.iframe
      const win = iframe.contentWindow || iframe
      const doc = iframe.contentDocument || iframe.contentWindow.document

      // write in frame
      doc.open()
      doc.write(`<html><head></head><body>${html}</body></html>`)
      doc.close()

      // style frame
      doc.body.style.padding = 0
      doc.body.style.margin = 0
      doc.body.style.color = this.color
      doc.body.style.fontFamily = this.fontFamily
      doc.body.style.fontSize = this.fontSize

      // add target links
      doc.body.querySelectorAll('a').forEach(el => {
        el.target = '_black'
      })

      // resize frame
      const height = Math.max(
          win.innerHeight,
          doc.body.offsetHeight,
          doc.documentElement.clientHeight
      )
      iframe.style.height = `${height}px`
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iframe{
  display: block;
  border: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Fields/HtmlFrame.vue